import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { mapResponseWithData } from '@sc/pas-common';
var FaqService = /** @class */ (function () {
    function FaqService(httpClient) {
        this.httpClient = httpClient;
    }
    FaqService.prototype.getQuestions = function () {
        return this.httpClient.get('./assets/json/faq.json?v=2').pipe(map(mapResponseWithData));
    };
    return FaqService;
}());
export { FaqService };
